import type { TAiChatToolPart } from '../interfaces/IAiChatTools';

/**
 * What the reply is doing with a tool call, by the state the part is in. Every state a tool part
 * can take has a key; a state the part type does not know yet is looked up as any string.
 */
const STATUS_KEY_BY_STATE: Record<string, string> = {
  'input-streaming': 'aiChat.toolRunning',
  'input-available': 'aiChat.toolRunning',
  'output-available': 'aiChat.toolDone',
  'output-error': 'aiChat.toolFailed',
} satisfies Record<TAiChatToolPart['state'], string>;

export default STATUS_KEY_BY_STATE;
